import type { PlaceWithDistance, SearchHit } from './types';
import { englishBeside, glossInline } from './ptEn';

const ACTIONS: { label: string; href: string; keywords: string[] }[] = [
  { label: 'Rocha Brava reception', href: '/resort', keywords: ['resort', 'reception', 'rocha', 'brava', 'home'] },
  { label: 'Bookings desk', href: '/resort', keywords: ['booking', 'reservas', 'reserve'] },
  { label: 'EWR ↔ LIS flights', href: '/flights', keywords: ['flight', 'ewr', 'lis', 'tap', 'united', 'newark'] },
  { label: 'Beach & travel safety', href: '/safety', keywords: ['safety', 'beach', 'uv', 'rip', 'cliff'] },
  {
    label: 'Pronunciation guide',
    href: '/pronunciation',
    keywords: ['pronunciation', 'speak', 'portuguese', 'say', 'audio'],
  },
  { label: 'Emergency 112', href: '/emergency', keywords: ['emergency', '112', 'police', 'ambulance'] },
  { label: 'Pharmacy / hospital', href: '/medical', keywords: ['pharmacy', 'farmacia', 'hospital', 'doctor'] },
  { label: "What's On", href: '/events', keywords: ['event', 'whats on', "what's on", 'market'] },
];

export function searchCatalog(query: string, places: PlaceWithDistance[]): SearchHit[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];

  const hits: SearchHit[] = [];

  for (const action of ACTIONS) {
    if (action.keywords.some((k) => k.includes(q) || q.includes(k)) || action.label.toLowerCase().includes(q)) {
      hits.push({ type: 'action', label: action.label, href: action.href });
    }
  }

  for (const place of places) {
    const english = [englishBeside(place.name), englishBeside(place.address)].filter(Boolean).join(' ');
    const hay = [place.name, english, place.address, glossInline(place.notes ?? ''), ...place.tags]
      .join(' ')
      .toLowerCase();
    if (hay.includes(q)) {
      hits.push({
        type: 'place',
        label: place.name,
        href: `/places/${place.slug}`,
        detail: place.notes,
        place,
      });
    }
  }

  return hits.slice(0, 12);
}
